<template>
  <div class="tab-pane fade" id="orders" role="tabpanel" aria-labelledby="orders-tab">
    <h1>{{$t("Apercu de mes commandes.")}}</h1>
    <font-awesome-icon :icon="['fas', 'spinner']" spin v-if="isLoading"  size="6x"/>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">{{$t("#")}}</th>
          <th scope="col">{{$t("Nom")}}</th>
          <th scope="col">{{$t("date")}}</th>
          <th scope="col">{{$t("lien de téléchargement")}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="order in orders" :key="order.dem_id">
          <th scope="row">{{order.dem_id}}</th>
          <td>{{order.dem_nom}}</td>
          <td>{{order.dem_date}}</td>
          <td><a  v-if="order.dem_download_url != null" :href="order.dem_download_url" target="_blank"><font-awesome-icon :icon="['fas', 'download']" /></a></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { ref } from 'vue';
export default {
  setup() {
    const orders = ref([]);
    const isLoading = ref(false);
    isLoading.value = true;
    fetch("api/getorders", {
        body: {},
        method: "post"
    }).then(function(resp) {
      resp.json().then(function(json) {
        orders.value = json['orders'];
        isLoading.value = false;
      }.bind(this));
    }.bind(this));

    return {
      orders,
      isLoading
    }
  }
}
</script>
